import {
  attachCustomsInfoSelector,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {UPS} from '../../../common/constants/ShipperNames.js'
import {getState, useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const VALID_SHIPPER_TYPES = [UPS]

const SENDER_TYPE_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return SENDER_TYPE_DEPENDENT_PROPERTIES
}

export function formatSenderTypeLabelProperty(shipperType) {
  return `${shipperType}__sender_type`
}

export function senderTypeLabelPropertiesFunc(shipperType, labelInfoID) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo ? [formatSenderTypeLabelProperty(shipperType)] : []
}

const VALID_SENDER_TYPE_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map(
  (shipperType) => formatSenderTypeLabelProperty(shipperType),
)

export default function SenderType() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = SenderType.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="Sender Type"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="entity_type"
      hide={!attachCustomsInfo}
    />
  )
}

SenderType.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: senderTypeLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_SENDER_TYPE_LABEL_PROPERTIES
    },
  },
]
